import React from "react";
import {
  BuyBtn,
  DescriptionTitle,
  ImageWrapper,
  MainSection,
  Name,
  Text,
  TimerDiv,
  Title,
  Type,
} from "./elements";
import {
  DarkButton,
  LightButton,
  MainCol,
  MainContainer,
  MainRow,
} from "components/common";
import { tokensaleimg } from "assets";
import { Image } from "react-bootstrap";
import FlipClockCountdown from "@leenguyen/react-flip-clock-countdown";
import "@leenguyen/react-flip-clock-countdown/dist/index.css";
import "animate.css/animate.min.css";
import { AnimationOnScroll } from "react-animation-on-scroll";
import CustomTimer from "./customTimer";
const TokenSaleComp = () => {
  const data = [
    {
      name: "Allocation:",
      type: "enterapp Token",
    },
    {
      name: "Token name:",
      type: "EnterApp Token",
    },
    {
      name: "Ticker Symbol:",
      type: "ENT",
    },
    {
      name: "Starting Price Pre-ICO:",
      type: "EnterApp Token for USD 0.08",
    },
    // {
    //   name: "Maximum Tokens produced:",
    //   type: "EnterApp Token for USD 0.12",
    // },
    {
      name: "Maximum Eroiy for Sale:",
      type: "Maximum Eroiy for Sale",
    },
    {
      name: "Fundraising Goal:",
      type: "USD 48 million",
    },
    {
      name: "Minimum Purchase:",
      type: "100 EnterApp Tokens",
    },
  ];

  return (
    <MainSection>
      <MainContainer>
        <AnimationOnScroll animateIn="animate__bounceIn">
          <Title>Token Sale (ICO)</Title>
        </AnimationOnScroll>

        <MainRow>
          <MainCol lg={7}>
            <AnimationOnScroll animateIn="animate__fadeInLeft">
              <ImageWrapper>
                <Image src={tokensaleimg} fluid />
              </ImageWrapper>
              <TimerDiv>
                <CustomTimer />
                {/* <FlipClockCountdown
                  to={new Date().getTime() + 24 * 3600 * 1000 + 5000}
                  labels={["DAYS", "HOURS", "MINUTES", "SECONDS"]}
                  labelStyle={{
                    fontSize: 12,
                    fontWeight: 500,
                    textTransform: "uppercase",
                    color: "#fff",
                  }}
                  digitBlockStyle={{ width: 40, height: 60, fontSize: 30 }}
                  dividerStyle={{ color: "white", height: 1 }}
                  separatorStyle={{ color: "red", size: "6px" }}
                /> */}
              </TimerDiv>
              <div className="btn-div">
                <LightButton btnText="Buy Token" />
              </div>
            </AnimationOnScroll>
          </MainCol>
          <MainCol lg={5}>
            <AnimationOnScroll animateIn="animate__fadeInRight">
              {data.map((item) => (
                <div className="d-flex justify-content-between">
                  <Name>{item.name}</Name>
                  <Type>{item.type}</Type>
                </div>
              ))}

              <DescriptionTitle>General Description</DescriptionTitle>
              <Text>
                EnterApp Token will be released on the basis of the Ethereum
                platform and fully comply with the ERC20* <br /> standard.
                <br />
                Support of this standard guarantees the compatibility of the
                token with third-party services (wallets, exchanges, listings,
                etc.), and provides easy integration.
              </Text>
            </AnimationOnScroll>
          </MainCol>
        </MainRow>
      </MainContainer>
    </MainSection>
  );
};

export default TokenSaleComp;
